// extracted by mini-css-extract-plugin
export default {"headerTitle":"requestHeader_headerTitle__XqTUs","header":"requestHeader_header__2G0KD"};